import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from 'ionic-angular';
import { TextControlComponent } from './text-control.component';
import { DirectivesModule } from '../../../../app/directives/directives.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        DirectivesModule
    ],
    declarations: [
        TextControlComponent
    ],
    exports: [
        TextControlComponent
    ]
})
export class TextControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/text/form/text-control.module.ts